/**
 * The free local AI's install and care (SDD ia-local-gratuita, task 7), desktop only: probe the
 * machine, install Ollama and OpenCode into the app's own folder (official sources, pinned hashes,
 * always behind the person's click), start the server, pull the model with progress, validate.
 */

import { invoke } from '@tauri-apps/api/core'
import { listen, type UnlistenFn } from '@tauri-apps/api/event'

export interface LocalAiProbe {
  supported: boolean
  ramGb: number | null
  freeDiskGb: number | null
  gpu: string | null
  ollamaInstalled: boolean
  ollamaRunning: boolean
  opencodeInstalled: boolean
  npmInstalled: boolean
  model: string | null
  modelPresent: boolean
}

export interface LocalAiProgress {
  stage: 'download' | 'unpack' | 'opencode' | 'pull' | 'done'
  detail: string
  percent: number | null
}

export interface LocalAiValidation {
  answered: boolean
  answerSeconds: number
}

export const localAiProbe = () => invoke<LocalAiProbe>('local_ai_probe')
export const localAiInstallOllama = () => invoke<void>('local_ai_install_ollama')
export const localAiInstallOpencode = () => invoke<void>('local_ai_install_opencode')
export const localAiStart = () => invoke<string>('local_ai_start')
export const localAiPull = (tag: string) => invoke<void>('local_ai_pull', { tag })
export const localAiSetModel = (tag: string) => invoke<void>('local_ai_set_model', { tag })
export const localAiValidate = () => invoke<LocalAiValidation>('local_ai_validate')

export function onLocalAiProgress(handler: (progress: LocalAiProgress) => void): Promise<UnlistenFn> {
  return listen<LocalAiProgress>('devpulse://local-ai', (event) => handler(event.payload))
}
